export default function fitBounds(map, items,latLngItem,n,e,s,w){
    
    if(items?.length === 0 && latLngItem === null) return;

    if(latLngItem){
        map.panTo(latLngItem);
        map.panBy(-w+e+100,0);
    }else if (items?.length !== 0){
        let minLat = 20.0;
        let maxLat = 46.0;
        let minLng = 122.0;
        let maxLng = 153.0;
    
        items.forEach((item)=>{
            if (item.startLat > minLat) {
                minLat = item.startLat;
            }
            if (item.startLat < maxLat) {
                maxLat = item.startLat;
            }
            if (item.startLng > minLng) {
                minLng = item.startLng;
            }
            if (item.startLng < maxLng) {
                maxLng = item.startLng;
            }
        });
    
        let latLngBounds = new window.google.maps.LatLngBounds(
            new window.google.maps.LatLng(maxLat, maxLng),
            new window.google.maps.LatLng(minLat, minLng)
        );
        setBounds(map, latLngBounds,n,e,s,w,true);
    }
}

function setBounds(map, bnd,n,e,s,w,isZoom,zm,cb)
{
    // 通常の fitBounds だと検索パネルの幅を考慮しないため、下記URLの方法で fitBounds している
    // https://stackoverflow.com/questions/21913116/exclude-overlaid-element-from-google-maps-viewport-bounds

    var prj = map.getProjection();
    if(!prj) return;

    var ne = prj.fromLatLngToPoint(bnd.getNorthEast()),
        sw = prj.fromLatLngToPoint(bnd.getSouthWest());

    if (cb){
        zm = isZoom ? map.getZoom() : zm;

        ne.x += (e / Math.pow(2, zm)); //右側のオフセット
        ne.y -= (n / Math.pow(2, zm)); //上側のオフセット 
        sw.x -= (w / Math.pow(2, zm)); //左側のオフセット 
        sw.y += (s / Math.pow(2, zm)); //下側のオフセット 
    }
    else{
        zm = isZoom ? null : map.getZoom();
        //1回限りのイベントリスナーをセット
        window.google.maps.event.addListenerOnce(map,'bounds_changed', ()=>{ setBounds(map, bnd,n,e,s,w,isZoom,zm,1)} );
    }
    map.fitBounds(new window.google.maps.LatLngBounds(
        prj.fromPointToLatLng(sw), prj.fromPointToLatLng(ne)));
}